/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export type GoalStatusTypes = 'draft' | 'requested' | 'open' | 'notapproved' | 'done' | 'incomplete' | 'concluded' | 'rejected';

export const GoalStatusTypes = {
    Draft: 'draft' as GoalStatusTypes,
    Requested: 'requested' as GoalStatusTypes,
    Open: 'open' as GoalStatusTypes,
    Notapproved: 'notapproved' as GoalStatusTypes,
    Done: 'done' as GoalStatusTypes,
    Incomplete: 'incomplete' as GoalStatusTypes,
    Concluded: 'concluded' as GoalStatusTypes,
    Rejected: 'rejected' as GoalStatusTypes
};

